export default __webpack_public_path__ + "static/img/vogue_scene_animated_0186.3541e11.webp";